import { render, staticRenderFns } from "./AssignTo.vue?vue&type=template&id=b5751c04&"
import script from "./AssignTo.vue?vue&type=script&lang=js&"
export * from "./AssignTo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports